module.exports = __webpack_public_path__ + "static/media/beepChat2.dab7a9a5.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audios/beepChat2.mp3
// module id = 2607
// module chunks = 0